import { DocumentTypesEnum } from "types";

export class DocumentTypeNormalizer {
  static normalize(fileType: string): string {
    const normalizedFileType = fileType.toLowerCase().replace(/\s+/g, "");
    return (
      Object.keys(DocumentTypesEnum).find(
        (key) => key.toLowerCase().replace(/_/g, "") === normalizedFileType,
      ) || "RESUME"
    );
  }
}
